import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMGroup } from "../graphql/mutations";
import {
  CreateLLMGroupInput,
  CreateLLMGroupMutation,
} from "../API";

export async function createLLMGroupAfterEdit(
  values: CreateLLMGroupInput
):Promise<GraphQLResult<CreateLLMGroupMutation>> {
  return API.graphql(
    graphqlOperation(createLLMGroup, {
      input: {
        name: values.name,
        status: values.status,
        projectId: values.projectId,
        description: values.description || "",
        systemInstructions: values.systemInstructions || "",
        systemInstructionsAction: values.systemInstructionsAction || "",
        order: values.order || 0,
      },
    })
  ) as Promise<GraphQLResult<CreateLLMGroupMutation>>;
}
